import { Link } from 'react-router-dom';
import { Button } from '@givebutter/primitives/button';
import EmptyButter from 'assets/js/pages/contacts/single/timeline/timeline-list/empty-state/empty-butter.svg?react';
import { TimelineItem } from 'assets/js/pages/contacts/single/timeline/timeline-list/item/TimelineItem';
import { ContactType } from 'constants/contacts';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { Contact } from 'types/domain';

interface TimelineListProps {
    activities: any[];
    contact: Contact;
    isLoading: boolean;
    fetchTimeLine: () => void;
}

const TimelineList = ({ activities, contact, fetchTimeLine, isLoading }: TimelineListProps) => {
    const { accountId } = useCurrentAccount();

    return (
        <div className="flex flex-grow flex-col justify-between">
            {!isLoading && (!activities.length || !contact) && (
                <div className="flex flex-col items-center justify-center gap-10">
                    <EmptyButter />
                    <div className="flex flex-col items-center justify-center gap-6 text-center">
                        <div className="text-2xl font-medium">
                            This contact doesn't have any history
                        </div>
                        <div>
                            When a contact makes a donation, buys a ticket, or you manually add an
                            event, those items will show up here. Reach out to{' '}
                            {contact.first_name_display} to get them involved!
                        </div>

                        {contact.type !== ContactType.Company && (
                            <Link to={`/accounts/${accountId}/engage`}>
                                <Button variant="solid">Engage</Button>
                            </Link>
                        )}
                    </div>
                </div>
            )}
            {activities.map((item, index) => (
                <TimelineItem
                    fetchTimeLine={fetchTimeLine}
                    item={item}
                    isLast={index === activities.length - 1}
                    key={item.id}
                />
            ))}
        </div>
    );
};

export default TimelineList;
